export default __webpack_public_path__ + "static/media/gallery-wip-emitter_11.8f3c1125.jpg";